import { DefaultTheme, Theme } from "@react-navigation/native";
import { colors } from "../theme";

const navigationColors: Theme["colors"] = {
  ...DefaultTheme.colors,
  primary: colors.onBackground,
  background: colors.background,
  card: colors.card,
  text: colors.onCard,
  border: colors.outline,
};

export const navigationTheme = {
  ...DefaultTheme,
  colors: navigationColors,
};
